<script>
export default {
    name: "LoadingSpinner"
}
</script>

<template>
    <span><i class="fa fa-arrows-rotate spin-animation mx-1"></i></span>
</template>

<style scoped>
.spin-animation {
    display: inline-block;
    animation: spin 1s linear infinite !important;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>